const prod = {
  apiGateway: {
    REGION: "ca-central-1",
    URL: "https://api.fansfirst.ca",
  },
};

let config = {};

switch (process.env.REACT_APP_STAGE) {
  case "production": {
    config = prod;
    break;
  }

  default: {
    config = prod;
  }
}

export default {
  ...config,
  ...{
    cognito: {
      REGION: "ca-central-1",
      USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      APP_CLIENT_ID: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
      IDENTITY_POOL_ID: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    },
  },
};
